import { generatePath } from 'react-router-dom';
import { MYLEARNING_URL_FRAGMENT } from '../../constants/Navigation';
export const getMyLearningUrl = tab => {
  return generatePath(`${MYLEARNING_URL_FRAGMENT}/:tab?`, {
    tab
  });
};